import {Injectable, NgZone} from '@angular/core';
import {DialogService} from "primeng/dynamicdialog";
import {isNative} from "../../utils";

@Injectable({
  providedIn: 'root'
})
export class KillSwitchService {

  constructor(
    private readonly dialogService: DialogService,
    private readonly ngZone: NgZone
  ) {
  }

  public initialize() {
    if (isNative) {
      // App.addListener('resume', () => {
      //   this.ngZone.run(() => {
      //     this.configService.config$.subscribe(async config => {
      //       const info = await App.getInfo();
      //       if (config.outdatedVersions.includes(info.version))
      //         this.dialogService.open(KillSwitchModalComponent, {
      //           header: 'Update required',
      //           width: '80%',
      //           height: '50%',
      //           closeOnEscape: false,
      //           closable: false,
      //           modal: true,
      //         })
      //     })
      //   });
      // }).then();
    }
  }
}
